import "./_evenement.scss";

import {ReactElement} from "react";

import iconLocation from "@/assets/iconLocation.svg";
import {evenement} from "@/types/evenement";

function EvenementModale({event}: {event: evenement}): ReactElement {
  return (
    <div className="eventModale">
      <h3>{event.libelle}</h3>
      <p>
        <img
          src={iconLocation}
          alt="icon de localisaiont"
          title="illustration représentant une localisation"
          loading="lazy"
        />
        {event.lieu}
      </p>
    </div>
  );
}

export default EvenementModale;
